define('modules/editor/models/property_groups/section_geometry',['require','exports','module','./base','lib/util'],function(require, exports, module){
  var BasePropertyGroup = require("./base"),
      util = require("lib/util");

  module.exports = BasePropertyGroup.extend({
    name: "sectionGeometry",
    properties: ["height", "width", "marginBottom", "wide"],
    generateStyles: function($el, id){
      return [{
        selector: "#" + id,
        rules: {
          "height": this.get("height") + "px",
          "width": this.get("width") + "px",
          "margin-bottom": this.get("marginBottom") + "px"
        }
      }, {
        selector: "#" + id + " .ed-inner-wrapper",
        rules: {
          "width": this.get("wide")? this.get("width") + "px" : ""
        }
      }];
    },
    validators: {
      height: function(attrs) {
        var value = parseInt(attrs.height);
        return this.isInteger(attrs.height) && this.isNumber(value) && value > 0;
      },
      width: function(attrs) {
        var value = parseInt(attrs.width);
        return this.isInteger(attrs.width) && this.isNumber(value) && value > 0;
      },
      marginBottom: function(attrs) {
        var value = parseInt(attrs.marginBottom);
        return this.isInteger(attrs.marginBottom) && this.isNumber(value) && (value >= 0);
      }
    }
  });

  //util.mixin(module.exports, require("../../behaviours/apply_css_properties"));


});

